import { useState } from "react";
import AppToast from "@/shared/ui/AppToast";

interface Props {
  message: string;
}

/**
 * Error-boundary fallback for on-demand chunks that render as overlays — drawers,
 * dialogs, popover contents. There is nowhere to put an error message where the
 * overlay would have been, and an inline one would land off-screen at the end of
 * the page, so this surfaces as a toast and leaves the layout untouched.
 */
export default function LazyLoadErrorToast({ message }: Readonly<Props>) {
  const [open, setOpen] = useState(true);

  return <AppToast message={open ? message : null} onClose={() => setOpen(false)} />;
}
